<template>
  <linking-login-component></linking-login-component>
</template>

<script>
import LinkingLoginComponent from "../../components/registration/linkingLoginComponent";
export default {
  name: "linkingLogin",
  components: { LinkingLoginComponent },
};
</script>

<style scoped></style>
